import "preline/preline"

let timer;
function hidem() {
    const shadowRoots = document.querySelectorAll("*");
    shadowRoots.forEach((element) => {
        if (!element.shadowRoot) {
            return;
        }

        const el = element.shadowRoot.querySelectorAll("[class^='_poweredBy_']");
        if (el.length === 0) {
            return;
        }

        el.forEach((element) => {
            element.style.visibility = "hidden";
        });

        clearInterval(timer);
    });
}

hidem();
timer = setInterval(hidem, 5);
